
import {useEffect, useState} from "react";
import {Button, Card, Col, Row} from "antd";
import loadScript from "../utils/script";

function Pricing(props) {


    useEffect(() => {
        initShop()
    }, []);

    let initShop = () => {
        loadScript('https://app.lemonsqueezy.com/js/lemon.js').then( () => {
            window.createLemonSqueezy()
            console.log('LEMON_SQUEEZY_READY',window.LemonSqueezy)
            // https://docs.lemonsqueezy.com/help/getting-started/test-mode
            if (window.LemonSqueezy) {
                window.LemonSqueezy.Setup({
                    eventHandler: (event) => {
                        console.log("LEMON",event)
                        if (event.event === 'Checkout.Success') {
                            if (event.data?.order?.data?.attributes?.first_order_item.product_id == 333611) {

                            }
                        }
                        if (event === 'close') {
                            console.log("Checkoutclosed")
                        }
                    }
                })
            }
        })
    }

    function openCheckout () {
        if (!window.LemonSqueezy) {
            return
        }
        console.log('window.LemonSqueezy',window.LemonSqueezy)
        const checkoutUrl = 'https://mocky.lemonsqueezy.com/buy/6e118147-d873-447c-a09e-9986b154361e';
        window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    return (
        <div className="pricing">
            {props.plans.map( (plan) => {
                return <Card key={plan.id} title={plan.title} bordered={false}>
                    <Price></Price>
                    <ul>
                        {plan.features.map((feature) => {
                            return <li key={feature.title}>{feature.title}</li>
                        })}
                    </ul>

                    <Button onClick={openCheckout} type="primary" className="cta">Upgrade</Button>
                </Card>
            })}
        </div>
    );
}


function Price(props) {


    return (
        <div className="price">
            <div className="curency">{props.currency}</div>
            <div className="value">{props.value}</div>
            <div className="term">{props.term}</div>
        </div>
    );
}


export default Pricing;
